import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dota',
  templateUrl: './dota.component.html',
  styleUrls: ['./dota.component.css']
})
export class DotaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
